import withPrivateRoute from './withPrivateRoute';

export default withPrivateRoute;
